import { useTranslation } from 'react-i18next'

import { useScreen } from '../../../../../hooks'
import { FormikField } from '../../../../Formik'
import { InputField } from '../../../../Input'
import { BUILDING_FORM_INSURANCE_CONTRACT_NUMBER_FIELD_MAX_LENGTH } from '../../BuildingForm.constants'

function ContractNumberField({ name }) {
  const { t } = useTranslation()

  const { isMobileScreenSize } = useScreen() // TODO make same by css media instead of useScreen

  return (
    <FormikField
      hasCounter
      Component={InputField}
      borderless={!isMobileScreenSize}
      fieldComponentProps={{
        label: `${t('Building.ContractNameLabelKey')}:`,
        shouldAdaptToMobileScreen: true,
      }}
      inline={isMobileScreenSize}
      maxLength={BUILDING_FORM_INSURANCE_CONTRACT_NUMBER_FIELD_MAX_LENGTH}
      name={name}
      placeholder={t('Building.ContractNamePlaceholderKey')}
    />
  )
}

export default ContractNumberField
